export const list = {
  merchantNo: {
    name: '商户号',
    key: 'merchantNo',
    show: true,
  },
  type: {
    name: '类型',
    key: 'type',
    show: true,
    custom: true,
  },
  createtime: {
    name: '创建时间',
    key: 'createtimeStr',
    show: true,
  },
  modifytime: {
    name: '修改时间',
    key: 'modifytimeStr',
    show: true,
  },
  editor: {
    name: '编辑人',
    key: 'editor',
    show: true,
  },
  accountTag: {
    name: '账户标识',
    key: 'accountTag',
    show: true,
  },
  appid: {
    name: '微信/支付宝appid',
    key: 'appid',
    show: true,
  },
  name: {
    name: '账户名称',
    key: 'name',
    show: true,
  },
  verifyRemark: {
    name: '操作',
    key: 'verifyRemark',
    show: true,
    width: 200,
    custom: true,
    fixed: 'right'
  },
};
